<template>
  <v-textarea v-model="input" :label="label" :error-messages="errorMessages" />
</template>

<script>
export default {
  name: 'JsonInput',
  props: {
    value: {},
    label: {
      type: String,
      default: 'JSON'
    }
  },
  data () {
    return {
      errorMessages: []
    }
  },
  computed: {
    input: {
      get () {
        return JSON.stringify(this.value, null, 2)
      },
      set (newVal) {
        if (this.isJson(newVal)) {
          this.$emit('input', JSON.parse(newVal))
          this.errorMessages = []
        } else {
          this.errorMessages = ['Invalid JSON']
        }
      }
    }
  },
  methods: {
    isJson (str) {
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/JsonInput.vue